import { atom } from "jotai";

export const windowWidthAtom = atom(window.innerWidth);
export const windowHeightAtom = atom(window.innerHeight);
